export function isBle(mac: string): boolean {
  return mac.length > 10 && (mac.startsWith('78') || mac.startsWith('99'));
}

export type TagStatus = 'online' | 'offline' | 'warning';
export type BatteryLevel = 'high' | 'mid' | 'low';

export interface Tag {
  id: string;
  name: string;
  mac: string;
  status: TagStatus;
  battery: number;
  batteryText: string;
  lastSeen: string;
  lastSeenMs: number;
  positionType: number;
  lastCommTime: string;
  lat: number;
  lng: number;
  heading: number;
  isMoving: boolean;
  speedKph: number;
  rawStatus: number;
  zone: string;
  ownerId: string;
  lowBatteryLevel: number;
  positionAccuracy: number;
  lastGpsFix: string;
  lastGpsFixDt: string;
  commandPassword: string;
  unitType: number;
  autoArmActive: boolean;
  autoArmData: string;
  batteryVoltageTxt: string | null;
  subscriptionExpiry: string | null;
  motionAlarmEnabled: boolean;
  commandsEnabled: boolean;
  subType: number;
  smsCredits: number;
  positionCredits: number;
  isContainerDoor: boolean;
  doorOpen: boolean | null;
}

export interface User {
  id: string;
  name: string;
  initials: string;
  email: string;
  role: 'admin' | 'operator' | 'viewer';
  active: boolean;
  avatarGradient: string;
  tagIds: string[];
}

export function getBatteryLevel(pct: number): BatteryLevel {
  if (pct >= 50) return 'high';
  if (pct >= 25) return 'mid';
  return 'low';
}

export interface AlertContact {
  value: string;
  type: 'email' | 'phone';
  geofence: boolean;
  motion: boolean;
  lowBattery: boolean;
}

export interface DeviceSettings {
  name: string;
  contacts: AlertContact[];
  batteryThreshold: number;
}
